module.exports = __webpack_public_path__ + "0d22ea9392bef85bf6a60dc089d5e1a5.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_xlarge_x1/public/games/sm_image_2_0.png
// module id = 491
// module chunks = 0